module.exports = __webpack_public_path__ + "static/media/search.70346c02.svg";